"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getType = exports.getStatus = exports.getAssetNamespace = void 0;
const types_1 = require("@shapeshiftoss/types");
const unchained_client_1 = require("@shapeshiftoss/unchained-client");
__exportStar(require("./bip44"), exports);
__exportStar(require("./utxoUtils"), exports);
const getAssetNamespace = (type) => {
    if (type === 'ERC20')
        return 'erc20';
    if (type === 'ERC721')
        return 'erc721';
    throw new Error(`Unknown asset namespace. type: ${type}`);
};
exports.getAssetNamespace = getAssetNamespace;
const getStatus = (status) => {
    if (status === unchained_client_1.Status.Pending)
        return types_1.chainAdapters.TxStatus.Pending;
    if (status === unchained_client_1.Status.Confirmed)
        return types_1.chainAdapters.TxStatus.Confirmed;
    if (status === unchained_client_1.Status.Failed)
        return types_1.chainAdapters.TxStatus.Failed;
    return types_1.chainAdapters.TxStatus.Unknown;
};
exports.getStatus = getStatus;
const getType = (type) => {
    if (type === unchained_client_1.TransferType.Send)
        return types_1.chainAdapters.TxType.Send;
    if (type === unchained_client_1.TransferType.Receive)
        return types_1.chainAdapters.TxType.Receive;
    return types_1.chainAdapters.TxType.Unknown;
};
exports.getType = getType;
